const PREFIX = '/users';

const getEndPoint = (userId: string, url: string) =>
  `${PREFIX}/${userId}/${url}`;

const ACCOUNTS_ENDPOINTS = {
  CONNECTED_ACCOUNT_PROMPT: (userId: string): string =>
    getEndPoint(userId, 'connected_accounts/prompt'),
  CONNECTED_ACCOUNT_CALLBACK: (userId: string): string =>
    getEndPoint(userId, 'connected_accounts/callback'),
  CONNECTED_ACCOUNT_ADD_ACCOUNT: (userId: string): string =>
    getEndPoint(userId, 'connected_accounts/add_accounts'),
  CONNECTED_ACCOUNT_DELETE_ACCOUNT: (userId: string): string =>
    getEndPoint(userId, 'connected_accounts/delete_accounts'),
  LAST_UPDATE_DATE: (brandId: string): string =>
    `/brands/${brandId}/last_update_date`,
  REFRESH_LABELS: (brandId: string): string =>
    `/brands/${brandId}/labels/refresh`,
  LABELS: (brandId: string): string => `/brands/${brandId}/labels`,
  VIEWERS: (brandId: string): string => `/brands/${brandId}/viewers`
};

export default ACCOUNTS_ENDPOINTS;
